export default __webpack_public_path__ + "src/images/packages/kruger-sunset-lodge/2211a94a4f0a604c3f105e1b315498e8-5.jpg";